// Canonical URL utility functions to ensure consistent URLs across the application
// This helps fix redirect issues and improves SEO

const BASE_URL = 'https://freepomodorotimer.com';

/**
 * Gets the canonical URL for a given path
 * Ensures all URLs are consistent and use the preferred domain format
 */
export const getCanonicalUrl = (path: string): string => {
  // Remove leading slash if present, then add it back for consistency
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // For root path, return base URL without trailing slash for consistency
  if (!cleanPath || cleanPath === '') {
    return BASE_URL;
  }
  
  // For all other paths, return without trailing slash
  return `${BASE_URL}/${cleanPath}`;
};

/**
 * Route to canonical URL mapping
 * Ensures consistent URL structure across the application
 */
export const CANONICAL_URLS = {
  home: getCanonicalUrl('/'),
  pomodoro: getCanonicalUrl('/pomodoro'),
  eisenhower: getCanonicalUrl('/eisenhower'),
  tasks: getCanonicalUrl('/tasks'),
  kanban: getCanonicalUrl('/kanban'),
} as const;

/**
 * Gets canonical URL for current browser location
 * Useful for dynamic canonical URL generation
 */
export const getCurrentCanonicalUrl = (): string => {
  if (typeof window === 'undefined') {
    return BASE_URL;
  }
  
  const path = window.location.pathname;
  return getCanonicalUrl(path);
};